import { render, staticRenderFns } from "./FinalDecisionDialog.vue?vue&type=template&id=2889e2e2"
import script from "./FinalDecisionDialog.vue?vue&type=script&lang=js"
export * from "./FinalDecisionDialog.vue?vue&type=script&lang=js"
import style0 from "./FinalDecisionDialog.vue?vue&type=style&index=0&id=2889e2e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports